module.exports = __webpack_public_path__ + "img/vox-logo-no-text.83d5e501.png";